import React from 'react';
import MembershipSearchTemplate from '../../components_membership_hotel/template/hotel/membershipSearchTemplate';
import { getReserveList, getSenyuNenList, getVacancy2Month, selectSaveSearchInfo } from '../../const';
import messageConst from '../../const/messageConst';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from '../../resources/js/common/common';
import commonUtil from '../../common/commonUtil';
// import { confirmHotelReservation, getFavoriteCondition } from "../../const";

class MembershipSearch extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            membershipPopup: false,
            reservationPopup: false,
            // カレンダーモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            // 施設カレンダーモーダル
            facilityCalendarPopup: false,
            // 施設空室状況情報
            facilityVacancyInfo: {
                facilityId: "",
                facilityName: "",
                facilityTel: "",
                vacancyDateList: []
            },
            // カレンダー検索条件
            searchVacancyParam: {
                keiyakuNo: "",
                roomGradeList: [],
                startDate: "",
                shisetsuCdList: [],
                roomCnt: 0,
                guestCnt: 0,
                riyoKaiinKenSbtKbn: ""
            },
            // 部屋詳細モーダル
            roomDetailPopup: false,
            roomInfo: {},
            // レストラン空き状況照会モーダル
            restaurantVacancyPopup: false,
            restaurantInfo: {},
            restaurantVacancyInfo: [],
            // 施設ID
            facilityId: "",
            // ポップアップ用施設空室状況情報
            vacancyInfo: [],
            memberVacancyInfo: [],
            ippanVacancyInfo: [],
            // 予約確認モーダル
            membershipReservationConfPopup: false,
            reservationConfList: [],
            // 予約キャンセルモーダル
            membershipReservationCancelPopup: false,
            // メッセージモーダル表示
            messagePopup: false,
            // メッセージモーダルのメッセージ
            messagePopupMessage: null,
            // ローディング画面表示フラグ
            loadingFlg: false,
            // 占有日モーダル
            selectKeiyakuNo: "",
            senyuubiPopup: false,
            shokaKenriNenList: [],
            openFacilityFlg: true,
            // 「ホームFLとは」モーダル
            descHomeFlPopup: false,
        };
    };

    render() {

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            },
        }
        // 検索条件保存モーダル
        const onClickOpenSavedSearchCriteriaWindow = (id, loginId) => {
            this.setState({
                membershipPopup: !this.state.membershipPopup,
                popupData: {},
                popupDataList: [],
                resData: {}
            });
            let title = "";
            if (id != undefined) {
                if (id == 'savedSearch') {
                    title = "保存した検索条件"
                    common.doPost(selectSaveSearchInfo, { memberCode: loginId }, afterSelectSaveSearchInfo);
                    // let dataList = [
                    //     {
                    //         label: "施設",
                    //         text: "東京ベイコート俱楽部",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "ご利用人数",
                    //         text: "大人　1人\n小人　1人",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "室数",
                    //         text: "2室",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "詳細条件",
                    //         text: "朝食あり",
                    //         type: "row"
                    //     }
                    // ]
                    // this.setState(
                    //     {
                    //         popupDataList: dataList,
                    //         resData: {}
                    //     }
                    // );
                }
                else if (id == 'bookConfirm') {
                    title = "予約確認"
                    // common.doPost(confirmHotelReservation, { loginId: loginId }, afterConfirmHotelReservation);
                }
                this.setState(
                    {
                        popupMode: id,
                        popupTitle: title
                    }
                );
            }
        }
        // 保存した検索条件取得後処理
        const afterSelectSaveSearchInfo = (res) => {
            let resData = res.data;
            let dataList = [];
            if (resData.resultCode == 0) {
                let facility = resData.shisetsuData ? resData.shisetsuData : "";
                let roomCnt = resData.numberOfRoom ? resData.numberOfRoom + "室" : "";
                let adultCnt = resData.numberOfAdult ? resData.numberOfAdult + "人" : "";
                let childCnt = resData.numberOfChild ? resData.numberOfChild + "人" : "";
                let humanNum = "";
                if (adultCnt) {
                    humanNum = "大人　" + adultCnt + (childCnt ? "\n小学生　" + childCnt : "");
                } else {
                    humanNum = childCnt ? "小学生　" + childCnt : "";
                }
                let detailCondition = resData.detailedConditionsList ? resData.detailedConditionsList : "";
                dataList = [
                    {
                        label: "ホテル",
                        text: facility,
                        type: "row"
                    },
                    {
                        label: "ご利用人数",
                        text: humanNum,
                        type: "row"
                    },
                    {
                        label: "室数",
                        text: roomCnt,
                        type: "row"
                    },
                    {
                        label: "詳細条件",
                        text: detailCondition,
                        type: "row"
                    }
                ]
                this.setState(
                    {
                        popupDataList: dataList,
                        resData: resData,
                        reservationPopup: true
                    }
                );
            } else {
                this.setState(
                    {
                        popupMode: "message",
                        popupMessage: messageConst.NOT_SAVED_SEARCH
                    }
                );
            }
        }
        // 予約情報取得後処理
        const afterConfirmHotelReservation = (res) => {
            const data = res.data;
            if (data.resultCode != 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reserve,
                    }
                );
            }
        }

        // カレンダーモーダル
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'checkIn') {
                    checkInFlg = true;
                    checkOutFlg = false;
                    title = "チェックイン"
                }
                else if (e.target.id == 'checkOut') {
                    checkInFlg = false;
                    checkOutFlg = true;
                    title = "チェックアウト"
                }
                this.setState(
                    {
                        checkInFlg: checkInFlg,
                        checkOutFlg: checkOutFlg,
                        popupTitle: title
                    }
                );
            }
        }

        // メッセージモーダル
        const onClickOpenMessageWindow = (message) => {
            this.setState({ messagePopup: true, messagePopupMessage: message });
        }
        // メッセージモーダル
        const onClicCloseMessageWindow = (e) => {
            this.setState({ messagePopup: false });
        }

        // 施設カレンダーモーダル
        const onClickOpenFacilityCalendarWindow = (req, name, dispStartDate) => {
            this.setState(
                {
                    facilityCalendarPopup: !this.state.facilityCalendarPopup,
                    calendarStartDate: dispStartDate,
                    facilityId: req.shisetsuCdList[0] ? req.shisetsuCdList[0] : "",
                    facilityCalendarFlg: true,
                    popupTitle: name ? name : ""
                }
            );
            // カレンダー検索用検索情報取得
            req.startDate = commonUtil.getStringFromDate(req.startDate, "yyyy-MM-dd"); //日付をフォーマット
            common.doPost(getVacancy2Month, req, afterGetVacancy2Month);
        }

        // チェックリストモーダル
        const onClickOpenCheckListWindow = (e) => {
            this.setState({ checkListPopup: !this.state.checkListPopup });
            let facilityFlg = false;
            let detailCriteriaFlg = false;
            let gradeFlg = false;
            let roomDetailCriteriaFlg = false;
            let title = "";
            if (e !== undefined) {
                if (e.target.id === 'facility') {
                    facilityFlg = true;
                    detailCriteriaFlg = false;
                    gradeFlg = false;
                    title = "エリア・ホテル"
                } else if (e.target.id === 'detailCriteria') {
                    facilityFlg = false;
                    detailCriteriaFlg = true;
                    gradeFlg = false;
                    title = "詳細条件"
                } else if (e.target.id === 'grade') {
                    facilityFlg = false;
                    detailCriteriaFlg = true;
                    title = "グレード"
                    gradeFlg = true;
                } else if (e.target.id === 'roomDetailCriteria') {
                    facilityFlg = false;
                    detailCriteriaFlg = false;
                    title = "部屋詳細条件"
                    gradeFlg = false;
                    roomDetailCriteriaFlg = true;
                }
                this.setState(
                    {
                        facilityFlg: facilityFlg,
                        detailCriteriaFlg: detailCriteriaFlg,
                        popupTitle: title,
                        gradeFlg: gradeFlg,
                        roomDetailCriteriaFlg: roomDetailCriteriaFlg
                    });
            }
        }

        // カレンダー検索用検索情報取得
        const onClickCalendarMove = (req) => {
            // カレンダー検索用検索情報取得
            common.doPost(getVacancy2Month, req, afterGetVacancy2Month);
        }
        // カレンダー検索用検索情報取得後処理
        const afterGetVacancy2Month = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                let shisetsuCd = "";
                let shisetsuName = "";
                let shisetsuTel = "";
                let facilityVacancyList = [];
                data.kushitsuList.forEach((value, index) => {
                    if (index === 0) {
                        shisetsuCd = value.shisetsuCd;
                        shisetsuName = value.shisetsuName;
                        shisetsuTel = value.shisetsuTel;
                        facilityVacancyList = value.kushitsuDateList;
                    }
                })
                this.setState({
                    facilityVacancyInfo: {
                        facilityId: shisetsuCd,
                        facilityName: shisetsuName,
                        facilityTel: shisetsuTel,
                        vacancyDateList: facilityVacancyList
                    }
                });
            }
        }

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true, loadingFlg: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId }, afterGetReserveList);
        }
        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
            this.setState({ loadingFlg: false });
        }

        // ポップアップ用施設空室状況情報設定
        const setVacancyInfo = (list) => { this.setState({ vacancyInfo: list }); };

        // カレンダー検索条件設定
        const setSearchVacancyParam = (param) => {
            this.setState({
                searchVacancyParam: param
            })
        }

        // 部屋詳細ポップアップ表示
        const onClickOpenRoomDetailPopup = (room) => {
            this.setState({
                roomDetailPopup: true,
                roomInfo: room,
            });
        }

        // 部屋詳細モーダルClose
        const onClickCloseRoomDetailPopup = () => { this.setState({ roomDetailPopup: false }); };

        // レストラン空き状況照会モーダル
        const onClickOpenRestaurantVacancyPopup = (restaurantVacancyInfo, restaurantInfo, riyoDate) => {
            this.setState({ restaurantVacancyPopup: true, restaurantVacancyInfo: restaurantVacancyInfo, restaurantInfo: restaurantInfo, riyoDate: riyoDate });
        }

        // レストラン空き状況照会モーダルを閉じる
        const onClickCloseRestaurantVacancyPopup = () => { this.setState({ restaurantVacancyPopup: false }); };

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }

        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // モーダルを閉じる
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false, reservationPopup: false }); };
        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };
        // 施設カレンダーモーダル
        const onClickCloseFacilityCalendarWindow = () => { this.setState({ facilityCalendarPopup: false }); }
        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };
        // 選択契約番号設定
        const setSelectKeiyakuNo = (keiyakuNo) => this.setState({ selectKeiyakuNo: keiyakuNo })

        // 占有日モーダル
        const onClickOpenSenyuubiWindow = (keiyakuNo) => {
            common.doPost(getSenyuNenList, { keiyakuNo: keiyakuNo }, afterGetSenyuNenList);
        }

        // 占有日一覧取得後処理
        const afterGetSenyuNenList = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                this.setState({
                    senyuubiPopup: true,
                    shokaKenriNenList: data.shokaKenriNenList
                });
            } else {
                this.setState({
                    senyuubiPopup: true,
                    shokaKenriNenList: []
                });
            }
        }

        // 「ホームFlとは」モーダル
        const onClickOpenDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: true }); };

        // 占有日モーダルを閉じる
        const onClickCloseSenyuubiPopupWindow = () => { this.setState({ senyuubiPopup: false }); };

        // 開業施設フラグ設定
        const setOpenFacilityFlg = (flg) => { this.setState({ openFacilityFlg: flg }); };

        // 「ホームFlとは」モーダルを閉じる
        const onClickCloseDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: false }); };

        return (
            <div style={style.base}>
                <MembershipSearchTemplate
                    state={this.state}
                    onClickOpenSavedSearchCriteriaWindow={onClickOpenSavedSearchCriteriaWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenFacilityCalendarWindow={onClickOpenFacilityCalendarWindow}
                    onClickCalendarMove={onClickCalendarMove}
                    setVacancyInfo={setVacancyInfo}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickCloseFacilityCalendarWindow={onClickCloseFacilityCalendarWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    setPopupMode={setPopupMode}
                    setPopupMessage={setPopupMessage}
                    setSelectKeiyakuNo={setSelectKeiyakuNo}
                    setOpenFacilityFlg={setOpenFacilityFlg}
                    onClickOpenMessageWindow={onClickOpenMessageWindow}
                    onClicCloseMessageWindow={onClicCloseMessageWindow}
                    onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                    onClickCloseRoomDetailPopup={onClickCloseRoomDetailPopup}
                    onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                    onClickCloseRestaurantVacancyPopup={onClickCloseRestaurantVacancyPopup}
                    setSearchVacancyParam={setSearchVacancyParam}
                    onClickOpenSenyuubiWindow={onClickOpenSenyuubiWindow}
                    onClickCloseSenyuubiPopupWindow={onClickCloseSenyuubiPopupWindow}
                    onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                    onClickCloseDescriptionHomeFlWindow={onClickCloseDescriptionHomeFlWindow}
                />
            </div>
        )
    }
}
export default MembershipSearch;
